import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MeService } from 'src/app/shared/services/me.service';

/**
 * Lässt nur Company Admins (User.companyAdmin via /v2/me) auf die Route. Lädt /v2/me
 * nach, falls noch nicht geschehen (Deep-Link direkt auf die URL). Nicht-Admins werden
 * auf die Startseite umgeleitet — das Backend erzwingt die Berechtigung ohnehin (403).
 */
export const CompanyAdminGuard: CanActivateFn = async () => {
  const meService = inject(MeService);
  const router = inject(Router);

  if (!meService.loaded()) {
    try {
      await meService.refresh();
    } catch {
      return router.createUrlTree(['/']);
    }
  }
  return meService.isCompanyAdmin() ? true : router.createUrlTree(['/']);
};
